import { render } from "./DistributorDashboard.vue?vue&type=template&id=973ee45a&scoped=true"
import script from "./DistributorDashboard.vue?vue&type=script&lang=js"
export * from "./DistributorDashboard.vue?vue&type=script&lang=js"

import "./DistributorDashboard.vue?vue&type=style&index=0&id=973ee45a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-973ee45a"]])

export default __exports__